import { showErrorToast, showSuccessToast } from "utils/toast";

import { toggleDownloadOverduePatientModal } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import { useDownloadOverduePatientListMutation } from "app/store/patient/api/patientApi";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const useNonCompliantPatientToolbar = () => {
  const dispatch = useDispatch();

  const { account, showDownloadOverdueModal } = useSelector(
    (state) => state.nonCompliantPatient
  );

  const [downloadOverduePatientList, { isLoading: isDownloadingOverdueList }] =
    useDownloadOverduePatientListMutation();

  const handleDownloadOverduePatientModal = (status) => {
    dispatch(toggleDownloadOverduePatientModal(status));
  };

  const handleDownloadOverduePatients = async (payload) => {
    try {
      const query = {
        account: account !== "all" ? account : null,
        noShowType: "overdue",
        ...payload,
      };
      const response = await downloadOverduePatientList(query);

      if (response) {
        handleDownloadOverduePatientModal(false);
        showSuccessToast("Overdue patient list downloaded successfully.");
      }
    } catch (error) {
      showErrorToast(error?.message);
    }
  };

  return {
    handleDownloadOverduePatients,
    handleDownloadOverduePatientModal,
    isDownloadingOverdueList,
    showDownloadOverdueModal,
  };
};

export default useNonCompliantPatientToolbar;
